export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PostShare.vue?vue&type=template&id=32943daa&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PostShare.vue?vue&type=template&id=32943daa&scoped=true&
// module id = 347
// module chunks = 0